const menu = () =>
    import('@/module/index/components/caseDetail/menuDetail.vue')
export default {
  path: '/menu',
  component: menu
}



// WEBPACK FOOTER //
// ./src/publicResource/router/test.js